// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"759b43ea","208":"7444cf58","419":"61b49e21","439":"2dbd7345","459":"4fa8563b","631":"43326995","774":"2de04955","787":"5d1f09f5"}[chunkId] + ".chunk.js";
};